import React from 'react';
import { isNullOrUndefined } from '../../helpers/object-helpers';
import styles from './AssistiveText.module.scss';

export interface IAssistiveText {
  children?: React.ReactNode;
}

export default function AssistiveText({ children }: IAssistiveText) {
  return !isNullOrUndefined(children) ? (
    <small className={styles.assistiveText}>{children}</small>
  ) : null;
}
